var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.28 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:none;}.h{fill:url(#f);}.i{fill:url(#e);}.j{fill:url(#d);}.k{fill:url(#c);}.l{fill:url(#b);}.m{fill:#50d086;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 387.4,
    y1: 436.08,
    x2: 412.65,
    y2: 410.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5b96f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37cb89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 241.22,
    y1: 377.21,
    x2: 266.47,
    y2: 351.97,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 188.47,
    y1: 530.4,
    x2: 403.18,
    y2: 315.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b96f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#34b1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37cb89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 156.23,
    y1: 305.42,
    x2: 156.23,
    y2: 87.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b96f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34b1e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 295.34,
    y1: 236.39,
    x2: 295.34,
    y2: 18.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#34b1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37cb89"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M417.88,423.46c0,9.86-7.99,17.85-17.85,17.85s-17.85-7.99-17.85-17.85,7.99-17.85,17.85-17.85,17.85,7.99,17.85,17.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M271.7,364.59c0,9.86-7.99,17.85-17.85,17.85s-17.85-7.99-17.85-17.85,7.99-17.85,17.85-17.85,17.85,7.99,17.85,17.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M295.83,271.22c-83.85,0-151.82,67.97-151.82,151.82,0,13.89,1.88,27.35,5.37,40.13,20.68.67,37.25,17.64,37.25,38.49,0,7.5-2.15,14.5-5.86,20.42,27.84,32.32,69.06,52.78,115.06,52.78,83.85,0,151.82-67.97,151.82-151.82s-67.97-151.82-151.82-151.82ZM212.35,364.61c0-22.93,18.59-41.53,41.53-41.53s41.53,18.59,41.53,41.53-18.59,41.53-41.53,41.53-41.53-18.59-41.53-41.53ZM283.58,499.98c-13.08,0-23.68-10.6-23.68-23.68s10.6-23.68,23.68-23.68,23.68,10.6,23.68,23.68-10.6,23.68-23.68,23.68ZM336.27,359.17c-9.86,0-17.85-7.99-17.85-17.85s7.99-17.85,17.85-17.85,17.85,7.99,17.85,17.85-7.99,17.85-17.85,17.85ZM400.07,460.01c-20.13,0-36.45-16.32-36.45-36.45s16.32-36.45,36.45-36.45,36.45,16.32,36.45,36.45-16.32,36.45-36.45,36.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M451.23,297.15c0,4.57-3.7,8.27-8.27,8.27s-8.27-3.7-8.27-8.27V95.35c0-4.57,3.7-8.27,8.27-8.27s8.27,3.7,8.27,8.27v201.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M164.5,297.15c0,4.57-3.7,8.27-8.27,8.27s-8.27-3.7-8.27-8.27V95.35c0-4.57,3.7-8.27,8.27-8.27s8.27,3.7,8.27,8.27v201.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M303.6,228.12c0,4.57-3.7,8.27-8.27,8.27s-8.27-3.7-8.27-8.27V26.32c0-4.57,3.7-8.27,8.27-8.27s8.27,3.7,8.27,8.27v201.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 595.28,
    height: 595.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e2043f6c68c91fbb83c172f580c6290.svg";
export { ForwardRef as ReactComponent };